












































































































































































































import Vue from "vue"
import Component from "vue-class-component"

import Page from "custom/Page.vue"
import ContentHeader from "custom/ContentHeader.vue"

import NavigationTab from "custom/NavigationTab.vue"
import NavigationTabItem from "custom/NavigationTabItem.vue"
import FlexCard from "custom/FlexCard.vue"
import Amount from "custom/Amount.vue"
import Tooltip from "components/supplemental/Tooltip.vue"

@Component({
	components: {
		Page,
		ContentHeader,
		NavigationTab,
		NavigationTabItem,
		FlexCard,
		Amount,
		Tooltip
	}
})
export default class PensionDetails extends Vue {

	personinfo = {
		accrualPercentage: 1.875,
		accruedBenefit: 1571.63,
		email: "Zot@test.nl",
		employmentUid: "$KaKFkuvNMQB9ulX5lw",
		expectedBenefit: 45367.58,
		lowerThreshold: 13344,
		monthlyEmployeePremium: 1161.28,
		personUid: "$KaKFkufNLuCdA73OU7",
		startDate: "2018-01-01",
		upperThreshold: 105075,
		PDLOPAccrued: 22262.47,
		PDLOPAccrued1: 2262.47,
		PDLOPAccrued2: 18547.47,
		PDLOPAccrued3: 12658.47,
		PDLOPAccrued4: 8543.47,
		PDLOPExpected: 54012.5,
		PDLOPExpected1: 44569.5,
		PDLOPExpected2: 33215.5,
		PDCAP: 0,
		PDCAPExpected: 0,
		PDWIA: 52306.4,
		PDPPBeforeAOW: 38854.54,
		PDPPAfterAOW: 23485.54,
		PDPPOrphan: 27085,
		PDPPOrphan1: 11589,
		PDPPOrphan2: 218,
		PDPPOrphan3: 32306
	}
}
